<template>
	<div v-if="user">
		<div style="padding: 10px">
			<app-breadcrumb :history="breadcrumb" @mutate="doMutate" />
			<router-view />
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"

export default {
	name: "setting-layout",
	components: {
		AppBreadcrumb
	},

	data() {
		return {
			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight,
			mobile: window.innerWidth < 900
		}
	},
	computed: {
		...mapGetters({
			user: "user/user",
			breadcrumb: "project/breadcrumb"
		})
	},
	methods: {
		...mapActions({
			doMutate: "project/doMutate"
		})
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";
.main {
	margin-top: -25px;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.item {
	padding: 17px 10px;
	cursor: pointer;
	color: #cfd8dc;
	width: 100%;
	&:hover {
		border-left: 3px solid #6ff9ff;
	}
	display: flex;
	.md-icon {
		margin-left: 5px;
		margin-right: 5px;
	}
	span {
		margin-top: auto;
		margin-bottom: auto;
	}
}

.item-selected {
	border-left: 3px solid #6ff9ff;
	color: white;
	background-color: rgba(127, 127, 127, 0.1);
}

.selected {
	color: #6ff9ff;
}
</style>
